import React from 'react'
import StudentOnboardingSurvey from 'src/pages/StudentOnboardingSurvey/StudentOnboardingSurvey'
import {
  OnboardingQuestion,
  OnboardingReason,
} from 'src/pages/StudentOnboardingSurvey/surveyData'
import { LanguageCode } from 'src/types'
import gql from 'graphql-tag'
import { useMutation } from 'react-apollo'
import { t } from 'src/lib/i18n-react'
import routes from 'src/lib/rails-routes/rails-routes'
import { getLanguageName } from 'lib/util'
import { postMessageToWebView } from 'lib/mobileHelper'
const SAVE_SURVEY_RESPONSE = gql`
  mutation TAKE_SURVEY($question: String!, $answer: String!) {
    takeSurvey(question: $question, answer: $answer) {
      errors {
        code
        message
      }
    }
  }
`

type Props = {
  l2Code: LanguageCode
  onShowSnackbar: ({ type, ...rest }: any) => void
  redirectTo: Location
  mobileAppToken: string
}

const SurveyLazy: React.FC<Props> = ({
  onShowSnackbar,
  l2Code,
  redirectTo,
  mobileAppToken,
}) => {
  const [saveSurveyResponse] = useMutation(SAVE_SURVEY_RESPONSE)
  const ctaText = redirectTo
    ? t('Save and proceed to next step')
    : t('Start learning %{languageName}', {
        languageName: getLanguageName(l2Code),
      })

  const handleTakeSurvey = async (
    question: OnboardingQuestion,
    answer: OnboardingReason,
    callback: (arg?: string) => void
  ) => {
    try {
      await saveSurveyResponse({
        variables: {
          question,
          answer,
        },
      })
      if (redirectTo) {
        window.location = redirectTo
      } else if (mobileAppToken) {
        postMessageToWebView('token', mobileAppToken)
      } else {
        window.location = routes.home_student({ code: l2Code })
      }
    } catch (e) {
      onShowSnackbar({
        message: t(
          'There was an error saving your response. Please refresh and try again.'
        ),
        type: 'error',
      })
      callback()
    }
  }

  return (
    <StudentOnboardingSurvey
      targetLanguageCode={l2Code}
      onSubmit={handleTakeSurvey}
      ctaText={ctaText}
    />
  )
}

export default SurveyLazy
